import React, { useEffect, useState, useCallback, useRef } from "react";
import { Modal, Tooltip } from "antd";
// import "./matchingRecordsTable.scss";
import TableWithStaticPagination from "../../table/tableWithStaticPagination";
import { isEmpty, map, sortBy } from "lodash";
import axios from "axios";
import sessionService from "@services/session.service";
import Icon from "@assets/icon_config";
import ExtraDetailsOfUser from "../../interventionCases/detailsOfUser/detailsOfUser";
import { formatDisplayDate } from "@utils/helpers";
import "./matchingMergdRecords.scss";
import { NoDataFound } from "@pages/member-details/care-coordination/components/care-plan-report/programPage/programPage";

const MatchingMergedRecords = (props: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const columnsList: any = useRef(null);

  useEffect(() => {
    let _columns = map(props.columnsNeedToShowInTable, (item) => {
      if (item.key === "member_empi_key") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          // sorter: (a: { [x: string]: any }, b: { [x: string]: any }) => a[item.dataIndex].localeCompare(b[item.dataIndex]),
          render: (value: any, record: any) => {
            return record.isOriginalRecord ? value : <div className="ui-empi-matching-merged-records__table__file-column">{record.file_name}</div>;
          },
        };
      }
      if (item.key === "action_desc") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          render: (value: any, record: any) => {
            return (
              <div className="ui-empi-matching-merged-records__table__action-column">
                <ExtraDetailsOfUser record={record} columnListForPopUp={props.columnsNeedToShowInPopUp} />
              </div>
            );
          },
        };
      } else if (item.key === "member_dob") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          // sorter: true,
          render: (value: any) => formatDisplayDate(value, "createDateFormat", "defaultDateFormat"),
        };
      } else if (item.key === "requested_on") {
        return {
          title: item.tableHeaderName,
          dataIndex: item.dataIndex,
          key: item.key,
          // sorter: true,
          render: (value: any) => formatDisplayDate(value, "reminderDateActualFormat", "defaultDateFormat"),
        };
      } else {
        return { ellipsis: true, title: item.tableHeaderName, dataIndex: item.dataIndex, key: item.key, render: (value: any) => value || "--" };
      }
    });

    _columns = sortBy(_columns, (item: any) => {
      return item.order;
    });

    columnsList.current = _columns;
  }, [props.columnsNeedToShowInPopUp, props.columnsNeedToShowInTable, props.payer]);

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const fetchData = useCallback(async () => {
    console.log("ExpandableTable.fetchData");
    setIsModalOpen(true);
    setLoading(true);
    const _data = await axios.post(`${sessionService.getClient()?.appServiceUrl}/empi/all-empi-master-matching-records`, { empiId: props.record.member_empi_key }).then((response) => {
      return response.data.data.records.allEMPIMasterMatchingRecords;
    });
    setData(_data);
    setLoading(false);
  }, [props.record.member_empi_key]);

  return (
    <>
      <Tooltip title="Merged Records Details">
        <span className="action-icon" onClick={() => fetchData()}>
          <Icon name="listDropDown" />
        </span>
      </Tooltip>
      <Modal width={1000} centered title="Record Info" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={[]}>
        <div className="ui-empi-matching-merged-records">
          <div className="ui-empi-matching-merged-records__header">
            <div className="ui-empi-matching-merged-records__header__name">{`${props.record.member_first_name} ${props.record.member_last_name} | `}</div>
            <div className="ui-empi-matching-merged-records__header__file"> {props.record?.file_name}</div>
          </div>
          <TableWithStaticPagination className="ui-empi-matching-merged-records__table" columns={columnsList.current} data={[{ ...props.record, isOriginalRecord: true }, ...data]} loading={loading} />
          {isEmpty(data) && !loading ? <NoDataFound /> : null}
        </div>
      </Modal>
    </>
  );
};

export default MatchingMergedRecords;
